export function useApi() {
    const API = process.env.VUE_APP_API;

    async function request(endpoint, options = {}) {
        const defaultHeaders = {
            'Content-Type': 'application/json',
        };

        try {
            const response = await fetch(`${API}${endpoint}`, {
                method: options.method || 'GET',
                headers: {
                    ...defaultHeaders,
                    ...options.headers,
                },
                body: options.body ? JSON.stringify(options.body) : null,
                redirect: 'follow',
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Error ${response.status}: ${errorText}`);
            }

            const contentType = response.headers.get('content-type');
            const raw = await response.text();

            if (!raw) {
                return null; // Пустой ответ
            }

            if (contentType && contentType.includes('application/json')) {
                try {
                    return JSON.parse(raw);
                } catch (e) {
                    console.error('Failed to parse JSON:', raw);
                    throw e;
                }
            }

            return raw;
        } catch (error) {
            console.error(`API request error:`, error);
            throw error;
        }
    }

    return {
        request,
    };
}
